// extracted by mini-css-extract-plugin
export default {"modalContainer":"V0-z","modalIndicator":"W0-z","prevBtn":"X0-z","nextBtn":"Y0-z","body":"Z0-z","footer":"_0-z"};